import React from 'react'
import { Users, Target, Globe, TrendingUp, Heart, Zap } from 'lucide-react'

const About = () => {
  const targetUsers = [
    {
      icon: Users,
      title: 'Nonprofits',
      description: 'Organizations working on social impact projects and community development'
    },
    {
      icon: Target,
      title: 'Researchers',
      description: 'Scientists and academics pursuing groundbreaking research initiatives'
    },
    {
      icon: Users,
      title: 'Students',
      description: 'Students seeking funding for education, projects, and academic pursuits'
    },
    {
      icon: Heart,
      title: 'Individuals',
      description: 'People with innovative ideas and passion for making a difference'
    },
    {
      icon: Zap,
      title: 'Social Enterprises',
      description: 'Businesses creating positive social and environmental impact'
    },
    {
      icon: TrendingUp,
      title: 'Startups',
      description: 'Early-stage companies building innovative solutions for global challenges'
    }
  ]

  const values = [
    {
      title: 'Global Access',
      description: 'We believe funding opportunities should be accessible to everyone, everywhere'
    },
    {
      title: 'Transparency',
      description: 'Clear, accurate information about grants and funding requirements'
    },
    {
      title: 'Empowerment',
      description: 'Tools and resources to help you succeed in your funding journey'
    },
    {
      title: 'Innovation',
      description: 'Supporting groundbreaking ideas that create positive change'
    }
  ]

  return (
    <div className="min-h-screen" data-component-path="client/src/pages/About.jsx" data-component-line="62:5" data-component-id="client/src/pages/About.jsx:62:5">
      <section className="bg-gradient-to-br from-blue-50 via-purple-50 to-pink-50 py-20" data-component-path="client/src/pages/About.jsx" data-component-line="63:7" data-component-id="client/src/pages/About.jsx:63:7">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-component-path="client/src/pages/About.jsx" data-component-line="64:9" data-component-id="client/src/pages/About.jsx:64:9">
          <div className="text-center" data-component-path="client/src/pages/About.jsx" data-component-line="65:11" data-component-id="client/src/pages/About.jsx:65:11">
            <h1 className="text-5xl md:text-6xl font-bold text-gray-900 mb-6" data-component-path="client/src/pages/About.jsx" data-component-line="66:13" data-component-id="client/src/pages/About.jsx:66:13">
              About GrantFlow
            </h1>
            <p className="text-xl md:text-2xl text-gray-600 max-w-3xl mx-auto" data-component-path="client/src/pages/About.jsx" data-component-line="69:13" data-component-id="client/src/pages/About.jsx:69:13">
              We're on a mission to democratize access to funding opportunities worldwide, 
              empowering changemakers to turn their visions into reality.
            </p>
          </div>
        </div>
      </section>

      <section className="py-16 bg-white" data-component-path="client/src/pages/About.jsx" data-component-line="77:7" data-component-id="client/src/pages/About.jsx:77:7">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-component-path="client/src/pages/About.jsx" data-component-line="78:9" data-component-id="client/src/pages/About.jsx:78:9">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center" data-component-path="client/src/pages/About.jsx" data-component-line="79:11" data-component-id="client/src/pages/About.jsx:79:11">
            <div data-component-path="client/src/pages/About.jsx" data-component-line="80:13" data-component-id="client/src/pages/About.jsx:80:13">
              <h2 className="text-4xl font-bold text-gray-900 mb-6" data-component-path="client/src/pages/About.jsx" data-component-line="81:15" data-component-id="client/src/pages/About.jsx:81:15">Our Story</h2>
              <div className="space-y-4 text-gray-600 text-lg" data-component-path="client/src/pages/About.jsx" data-component-line="82:15" data-component-id="client/src/pages/About.jsx:82:15">
                <p data-component-path="client/src/pages/About.jsx" data-component-line="83:17" data-component-id="client/src/pages/About.jsx:83:17">
                  GrantFlow was born from a simple observation: incredible ideas often go unfunded 
                  simply because the right people couldn't find the right opportunities at the right time.
                </p>
                <p data-component-path="client/src/pages/About.jsx" data-component-line="87:17" data-component-id="client/src/pages/About.jsx:87:17">
                  We built a platform that aggregates grants from around the world, covering climate action, 
                  sustainable development, research, education, arts, and business funding. Our intelligent 
                  search and alert system ensures you never miss an opportunity that matches your vision.
                </p>
                <p data-component-path="client/src/pages/About.jsx" data-component-line="92:17" data-component-id="client/src/pages/About.jsx:92:17">
                  Today, we serve over 50,000 users across 150 countries, helping them discover and secure 
                  funding for projects that create positive change in the world.
                </p>
              </div>
            </div>
            <div className="relative" data-component-path="client/src/pages/About.jsx" data-component-line="98:13" data-component-id="client/src/pages/About.jsx:98:13">
              <img
                src="https://images.pexels.com/photos/3184465/pexels-photo-3184465.jpeg?auto=compress&cs=tinysrgb&w=800"
                alt="Team collaboration"
                className="rounded-2xl shadow-2xl w-full h-96 object-cover"
                loading="lazy"
                onError={(e) => {
                  e.target.src = 'https://images.pexels.com/photos/3184291/pexels-photo-3184291.jpeg?auto=compress&cs=tinysrgb&w=800'
                }}
                data-component-path="client/src/pages/About.jsx" data-component-line="99:15" data-component-id="client/src/pages/About.jsx:99:15"
              />
            </div>
          </div>
        </div>
      </section>

      <section className="py-16 bg-gray-50" data-component-path="client/src/pages/About.jsx" data-component-line="113:7" data-component-id="client/src/pages/About.jsx:113:7">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-component-path="client/src/pages/About.jsx" data-component-line="114:9" data-component-id="client/src/pages/About.jsx:114:9">
          <div className="text-center mb-12" data-component-path="client/src/pages/About.jsx" data-component-line="115:11" data-component-id="client/src/pages/About.jsx:115:11">
            <h2 className="text-4xl font-bold text-gray-900 mb-4" data-component-path="client/src/pages/About.jsx" data-component-line="116:13" data-component-id="client/src/pages/About.jsx:116:13">Who We Serve</h2>
            <p className="text-xl text-gray-600" data-component-path="client/src/pages/About.jsx" data-component-line="117:13" data-component-id="client/src/pages/About.jsx:117:13">
              GrantFlow is designed for diverse communities of changemakers
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-component-path="client/src/pages/About.jsx" data-component-line="122:11" data-component-id="client/src/pages/About.jsx:122:11">
            {targetUsers.map((user, index) => (
              <div
                key={index}
                className="bg-white rounded-xl p-6 shadow-lg hover:shadow-xl transition-shadow"
                data-component-path="client/src/pages/About.jsx" data-component-line="124:17" data-component-id="client/src/pages/About.jsx:124:17"
              >
                <div className="w-12 h-12 bg-gradient-to-br from-blue-500 to-purple-600 rounded-lg flex items-center justify-center mb-4" data-component-path="client/src/pages/About.jsx" data-component-line="128:17" data-component-id="client/src/pages/About.jsx:128:17">
                  <user.icon className="w-6 h-6 text-white" data-component-path="client/src/pages/About.jsx" data-component-line="129:19" data-component-id="client/src/pages/About.jsx:129:19" />
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-2" data-component-path="client/src/pages/About.jsx" data-component-line="131:17" data-component-id="client/src/pages/About.jsx:131:17">{user.title}</h3>
                <p className="text-gray-600" data-component-path="client/src/pages/About.jsx" data-component-line="132:17" data-component-id="client/src/pages/About.jsx:132:17">{user.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="py-16 bg-white" data-component-path="client/src/pages/About.jsx" data-component-line="139:7" data-component-id="client/src/pages/About.jsx:139:7">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-component-path="client/src/pages/About.jsx" data-component-line="140:9" data-component-id="client/src/pages/About.jsx:140:9">
          <div className="text-center mb-12" data-component-path="client/src/pages/About.jsx" data-component-line="141:11" data-component-id="client/src/pages/About.jsx:141:11">
            <h2 className="text-4xl font-bold text-gray-900 mb-4" data-component-path="client/src/pages/About.jsx" data-component-line="142:13" data-component-id="client/src/pages/About.jsx:142:13">Our Values</h2>
            <p className="text-xl text-gray-600" data-component-path="client/src/pages/About.jsx" data-component-line="143:13" data-component-id="client/src/pages/About.jsx:143:13">
              The principles that guide everything we do
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-component-path="client/src/pages/About.jsx" data-component-line="148:11" data-component-id="client/src/pages/About.jsx:148:11">
            {values.map((value, index) => (
              <div
                key={index}
                className="bg-gradient-to-br from-blue-50 to-purple-50 rounded-xl p-8"
                data-component-path="client/src/pages/About.jsx" data-component-line="150:17" data-component-id="client/src/pages/About.jsx:150:17"
              >
                <h3 className="text-2xl font-bold text-gray-900 mb-3" data-component-path="client/src/pages/About.jsx" data-component-line="154:17" data-component-id="client/src/pages/About.jsx:154:17">{value.title}</h3>
                <p className="text-gray-600 text-lg" data-component-path="client/src/pages/About.jsx" data-component-line="155:17" data-component-id="client/src/pages/About.jsx:155:17">{value.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="py-16 bg-gradient-to-br from-blue-600 to-purple-600 text-white" data-component-path="client/src/pages/About.jsx" data-component-line="162:7" data-component-id="client/src/pages/About.jsx:162:7">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-component-path="client/src/pages/About.jsx" data-component-line="163:9" data-component-id="client/src/pages/About.jsx:163:9">
          <h2 className="text-4xl font-bold mb-6" data-component-path="client/src/pages/About.jsx" data-component-line="164:11" data-component-id="client/src/pages/About.jsx:164:11">Ready to Find Your Funding?</h2>
          <p className="text-xl mb-8 opacity-90" data-component-path="client/src/pages/About.jsx" data-component-line="165:11" data-component-id="client/src/pages/About.jsx:165:11">
            Join thousands of changemakers who are using GrantFlow to discover and secure funding for their projects.
          </p>
          <button className="flex items-center justify-center gap-2 h-14 px-8 bg-white text-blue-600 rounded-lg hover:shadow-xl transition-all duration-200 text-lg font-semibold mx-auto" data-component-path="client/src/pages/About.jsx" data-component-line="168:11" data-component-id="client/src/pages/About.jsx:168:11">
            <Globe className="w-6 h-6" data-component-path="client/src/pages/About.jsx" data-component-line="169:13" data-component-id="client/src/pages/About.jsx:169:13" />
            <span data-component-path="client/src/pages/About.jsx" data-component-line="170:13" data-component-id="client/src/pages/About.jsx:170:13">Start Exploring Grants</span>
          </button>
        </div>
      </section>
    </div>
  )
}

export default About